var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.players),function(player){return _c('Player',{attrs:{"player":player},on:{"cart-add-player":_vm.CartAddPlayer}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }